export type WebQueueVolumeTarget = {
  volume: number;
};

/**
 * Keep Video.js's private rolling media hosts on one session volume. Browsers
 * clamp HTML media volume to this range, but normalizing here also makes the
 * handoff safe for custom media targets and tests.
 */
export function mirrorWebQueueVolume(
  volume: number,
  targets: Array<WebQueueVolumeTarget | null>
): number | null {
  if (!Number.isFinite(volume)) return null;
  const normalized = Math.min(1, Math.max(0, volume));

  for (const target of targets) {
    if (!target || target.volume === normalized) continue;
    try {
      target.volume = normalized;
    } catch {
      // iOS/Safari can expose media volume while keeping it platform-owned.
      // Muting still works there; numeric volume continuity is unsupported.
    }
  }

  return normalized;
}
